
import { Component, Mixins } from 'vue-property-decorator';
import GroupEditor from '~/components/RemoteFeatureFlags/Groups/GroupEditor.vue';
import { FlagGroup } from '~/interfaces/user.interface';
import UserRightsMixin from '~/mixins/UserRightsMixin';
import { RemoteFeatureFlagsModule } from '~/store/modules/remoteFeatureFlags';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component({
    components: {
        GroupEditor
    }
})
export default class GroupsList extends Mixins(DarkThemeInfoMixin, UserRightsMixin) {
    selectedGroupId: string | null = null;
    editorDialog = false;

    openGroupEditor(group: FlagGroup) {
        this.selectedGroupId = group.id;
        this.editorDialog = true;
    }

    get selectedGroup() {
        if (!this.selectedGroupId) {
            return null;
        }
        return this.groups.find(g => g.id === this.selectedGroupId) || null;
    }

    get groups() {
        return RemoteFeatureFlagsModule.availableGroups;
    }
}
